import { cn } from "@/lib/utils";
import React from "react";
import { AccordionItemProps } from "@/components/ui/accordion/accordion-item";
import AccordionCIApp from "../ui/accordion-ci-app/accordion-ci-app";
import { useWindowSize } from "@/hooks/use-window-size";
import Image from "next/image";
import { StaticImageData } from "next/image";

export interface FAQsCIAppProps {
  id?: string;
  className?: string;
  heading?: string;
  items?: AccordionItemProps[];
  image?: {
    src: string | StaticImageData;
    alt: string;
  };
}

const FAQsCIApp: React.FC<FAQsCIAppProps> = ({
  id = "faqs",
  className,
  heading = "Frequently Asked Questions",
  items = [],
  image = {
    src: "",
    alt: "",
  },
}) => {
  const size = useWindowSize();

  return (
    <section
      id={id}
      aria-label={id}
      className={cn("w-full", className)}
    >
      <div className="mx-auto flex max-w-lg flex-col gap-6 px-4 py-8 md:gap-8 md:px-6 md:py-10 lg:flex-row lg:gap-14 lg:px-3">
        <div className="flex w-full flex-col gap-10">
          <h1 className="font-montserrat text-heading-4 text-secondary-500 md:text-heading-2">
            {heading}
          </h1>
          {size === "lg" && (
            <div className="flex w-full md:max-h-[384px] lg:max-h-[320px]">
              <Image
                src={typeof image.src === "string" ? image.src : image.src.src}
                alt={image.alt}
                className="w-full rounded-2xl object-cover"
                width={580}
                height={320}
                style={{
                  padding: "1px",
                  position: "relative",
                  background:
                    "linear-gradient(to bottom right, rgba(3, 125, 128, 0.4) 15.89%, rgba(2, 215, 221, 0.4) 33.42%, rgba(255, 214, 191, 0.4) 50.95%, rgba(255, 104, 22, 0.4) 68.47%, rgba(204, 73, 2, 0.4) 86.00%)",
                  boxShadow:
                    "4px 8px 32px 0px rgba(255, 213, 191, 0.69), -4px -8px 32px 0px rgba(196, 244, 245, 0.69)",
                }}
              />
            </div>
          )}
        </div>
        <div className="flex flex-col lg:min-w-[620px]">
          <AccordionCIApp items={items} />
        </div>
        {size === "md" && (
          <div className="flex w-full md:max-h-[384px]">
            <Image
              src={typeof image.src === "string" ? image.src : image.src.src}
              alt={image.alt}
              className="min-h-[320px] w-full rounded-2xl border border-neutral-200 object-cover"
              width={580}
              height={320}
              style={{
                padding: "1px",
                position: "relative",
                background:
                  "linear-gradient(to bottom right, rgba(3, 125, 128, 0.4) 15.89%, rgba(2, 215, 221, 0.4) 33.42%, rgba(255, 214, 191, 0.4) 50.95%, rgba(255, 104, 22, 0.4) 68.47%, rgba(204, 73, 2, 0.4) 86.00%)",
                boxShadow:
                  "4px 8px 32px 0px rgba(255, 213, 191, 0.69), -4px -8px 32px 0px rgba(196, 244, 245, 0.69)",
              }}
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default FAQsCIApp;
